import { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';

var IconStar = function() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--primary)', flexShrink: 0, marginTop: 1 }}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  );
};

var IconHeart = function() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--primary)' }}>
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
    </svg>
  );
};

export default function ReflexaoEmDestaque() {
  var [reflexao, setReflexao] = useState(null);
  var [loading, setLoading] = useState(true);

  useEffect(function() {
    var seteDiasAtras = new Date();
    seteDiasAtras.setDate(seteDiasAtras.getDate() - 7);

    supabase
      .from('reflexoes_anonimas')
      .select('id, texto, me_identifico_count, prompt, created_at')
      .gte('created_at', seteDiasAtras.toISOString())
      .gt('me_identifico_count', 0)
      .order('me_identifico_count', { ascending: false })
      .limit(1)
      .single()
      .then(function(res) {
        if (res.data) setReflexao(res.data);
        setLoading(false);
      });
  }, []);

  if (loading || !reflexao) return null;

  var texto = reflexao.texto || '';
  var truncado = texto.length > 200 ? texto.slice(0, 200) + '…' : texto;
  var count = reflexao.me_identifico_count;

  return (
    <div style={{
      background: 'var(--surface)',
      borderRadius: 'var(--r-lg)',
      border: '1px solid var(--border)',
      borderLeft: '3px solid var(--primary)',
      padding: '18px 20px',
      marginBottom: '28px',
    }}>
      {/* Cabeçalho com contexto */}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 7, marginBottom: 14 }}>
        <IconStar />
        <div>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: 'var(--primary)', margin: 0, textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 600 }}>
            Reflexão em destaque
          </p>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.75rem', color: 'var(--text-muted)', margin: '2px 0 0', lineHeight: 1.4 }}>
            a que mais gerou identificação nos últimos 7 dias
          </p>
        </div>
      </div>

      {/* Contagem de identificações em destaque */}
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5, marginBottom: 12, padding: '4px 10px', borderRadius: 'var(--r-full)', background: 'var(--lavender-light, #f0eef8)' }}>
        <IconHeart />
        <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', fontWeight: 600, color: 'var(--primary)' }}>
          {count} {count === 1 ? 'pessoa se identificou' : 'pessoas se identificaram'}
        </span>
      </div>

      {/* Prompt opcional */}
      {reflexao.prompt && (
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: 'var(--text-muted)', margin: '0 0 8px', fontStyle: 'italic' }}>
          "{reflexao.prompt}"
        </p>
      )}

      {/* Texto da reflexão */}
      <p style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: '1.05rem', color: 'var(--primary)', lineHeight: 1.65, margin: 0, fontStyle: 'italic' }}>
        "{truncado}"
      </p>
    </div>
  );
}
